import { scroller } from 'react-scroll'

export const scrollToContactForm = () =>
  scroller.scrollTo('contact-form', {
    duration: 700,
    smooth: true,
    offset: -70,
  })
